import changeActiveItem from '../modules/changeActiveItem'
import Cookies from 'js-cookie'


changeActiveItem('.js-change-active-item-orders')


const showOnKind = document.querySelectorAll('[show-on-kind]');
const showOnRadio = document.querySelectorAll('[show-on-radio]');

window.kindChange = function(el) {
	showOnKind.forEach(x => x.classList.add('hidden'))

	showOnKind.forEach(x => {
		let attribute = x.getAttribute('show-on-kind')
		if(attribute.includes(',')) attribute = attribute.split(',')

		if(!Array.isArray(attribute)) attribute = [attribute];
		attribute.forEach(y => {
			if(y == el.value){
				x.classList.remove('hidden')
			}
		})
	})
}

window.radioChange = function(el) {
	showOnRadio.forEach(x => {
		if(x.getAttribute('show-on-radio') == el.name){
			x.classList.add('inactive')
			x.querySelector('input').value = "";
			if(x.getAttribute('show-on-value') == el.value) x.classList.remove('inactive');
		}
	})
}

window.toggleFromList = function(index, list){
	const listDOM = document.querySelectorAll(list)
	listDOM.forEach(x => x.classList.add('hidden'))
	listDOM[index].classList.remove('hidden')
}


if(document.querySelector('.wpcf7')){
	const text1 = document.querySelector('.f-response-1').textContent
	const text2 = document.querySelector('.f-response-2').textContent
	const text3 = document.querySelector('.f-response-3').textContent

	const urlParams = new URLSearchParams(window.location.search);
	const title = urlParams.get('title');
	const selectDOM = document.querySelector('[name="division"]');
	if(title){
		selectDOM.value="Dział sprzedaży"
		if(Cookies.get('pll_language') == 'en') selectDOM.value="Sales Department"
		if(Cookies.get('pll_language') == 'de') selectDOM.value="Verkaufsabteilung"
		selectDOM.parentNode.classList.add('is-disabled')
	}
	const returnDOM = document.querySelector('[name="return"]');
	const renderMessage = () => {
		// if((selectDOM.value != "Dział sprzedaży" && selectDOM.value != "Dział produkcji") || (selectDOM.value != "Sales Department" && selectDOM.value != "Production Department") || (selectDOM.value != "Verkaufsabteilung" && selectDOM.value != "Produktionsabteilung")){
			returnDOM.value = text3
		// }
		if(selectDOM.value == "Dział sprzedaży" || selectDOM.value == "Sales Department" || selectDOM.value == "Verkaufsabteilung"){
			returnDOM.value = text1
		}
		if(selectDOM.value == "Dział produkcji" || selectDOM.value == "Production Department" || selectDOM.value == "Produktionsabteilung"){
			returnDOM.value = text2
		}
		console.log(returnDOM.value)
	}
	selectDOM.addEventListener('change', () => {
		renderMessage();
	})

	renderMessage();

	setInterval(()=>{
		renderMessage();
	},1000)
}